// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Agenda{
    display: flex;
    flex-direction: column;
    z-index: 3;
}
.Agenda_bg{
    height: 125vh;
    width: 100%;
    position: absolute;
    margin-top: -9rem;
    z-index: 1;
    clip-path: polygon(50% 0%, 100% 0, 100% 6%, 85% 100%, 0 7%, 0 0);    
    background-color: var(--bg-lgrey);
}
.text_AgendaCT{
    flex-direction: column;
    gap: 1rem;
    z-index: 2;
    padding: 8rem 15rem 5rem 15rem;
}
.agendaDot1{
    position: absolute;
    z-index: 10 !important;
    left: -2rem;
    margin-top: 1rem;
    transform: rotate(50deg);
}
.agendaDot2{
    position: absolute;
    z-index: 10 !important;
    right: 5rem;
    margin-top: -9rem;
}
@media only screen and (max-width: 1200px) {
    .Agenda_bg{
        margin-top: -10rem;
    }
    .text_AgendaCT{
        padding: 8rem 15rem 5rem 15rem;
    }

}
@media only screen and (max-width: 800px) {
    .Agenda_bg{
        margin-top: -12rem;
    }
    .text_AgendaCT{
        padding: 3rem;
    }
    .agendaDot1{
        display: none;
    }
    .agendaDot2{
        display: none;
}
}
@media only screen and (max-width: 550px) {
    .text_AgendaCT{
        padding: 3rem 2rem 3rem 2rem;
    }
    .Agenda_bg{
        margin-top: -19rem;
    }
}
@media only screen and (max-width: 540px) {
    .Agenda_bg{
        margin-top: -25rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Agenda/Agenda.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,gEAAgE;IAChE,iCAAiC;AACrC;AACA;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,8BAA8B;IAClC;;AAEJ;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;AACrB;AACA;AACA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".Agenda{\n    display: flex;\n    flex-direction: column;\n    z-index: 3;\n}\n.Agenda_bg{\n    height: 125vh;\n    width: 100%;\n    position: absolute;\n    margin-top: -9rem;\n    z-index: 1;\n    clip-path: polygon(50% 0%, 100% 0, 100% 6%, 85% 100%, 0 7%, 0 0);    \n    background-color: var(--bg-lgrey);\n}\n.text_AgendaCT{\n    flex-direction: column;\n    gap: 1rem;\n    z-index: 2;\n    padding: 8rem 15rem 5rem 15rem;\n}\n.agendaDot1{\n    position: absolute;\n    z-index: 10 !important;\n    left: -2rem;\n    margin-top: 1rem;\n    transform: rotate(50deg);\n}\n.agendaDot2{\n    position: absolute;\n    z-index: 10 !important;\n    right: 5rem;\n    margin-top: -9rem;\n}\n@media only screen and (max-width: 1200px) {\n    .Agenda_bg{\n        margin-top: -10rem;\n    }\n    .text_AgendaCT{\n        padding: 8rem 15rem 5rem 15rem;\n    }\n\n}\n@media only screen and (max-width: 800px) {\n    .Agenda_bg{\n        margin-top: -12rem;\n    }\n    .text_AgendaCT{\n        padding: 3rem;\n    }\n    .agendaDot1{\n        display: none;\n    }\n    .agendaDot2{\n        display: none;\n}\n}\n@media only screen and (max-width: 550px) {\n    .text_AgendaCT{\n        padding: 3rem 2rem 3rem 2rem;\n    }\n    .Agenda_bg{\n        margin-top: -19rem;\n    }\n}\n@media only screen and (max-width: 540px) {\n    .Agenda_bg{\n        margin-top: -25rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
